import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Navbar.css";

export default function Navbar() {
  const [click, setClick] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [username, setUsername] = useState("");

  const navigate = useNavigate();

  const getUserName = () => {
    const storedName = sessionStorage.getItem("name");
    if (storedName) {
      return storedName;
    }
    return username.split("@")[0];
  };

  const handleClick = () => setClick(!click);

  const handleLogout = () => {
    sessionStorage.removeItem("auth-token");
    sessionStorage.removeItem("name");
    sessionStorage.removeItem("email");
    sessionStorage.removeItem("phone");
    localStorage.removeItem("doctorData");
    localStorage.removeItem("appointmentData");

    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.startsWith("reviewFormData_")) {
        localStorage.removeItem(key);
      }
    }

    setIsLoggedIn(false);
    setUsername("");
    navigate("/");
    window.location.reload();
  };

  useEffect(() => {
    const storedEmail = sessionStorage.getItem("email");
    if (storedEmail) {
      setIsLoggedIn(true);
      setUsername(storedEmail);
    }
  }, []);

  return (
    <header>
      <nav className="nav">
        <div className="nav__logo">
          <Link to="/" className="nav__logo-link">
            <img
              src={`${process.env.PUBLIC_URL}/favicon-32.png`}
              alt=""
              className="nav__logo-icon"
              width="32"
              height="32"
            />
            <span className="nav__logo-text">StayHealthy</span>
          </Link>
        </div>
        <div className="nav__icon" onClick={handleClick}>
          <i className={click ? "fa fa-times" : "fa fa-bars"}></i>
        </div>
        <ul className={click ? "nav__links active" : "nav__links"}>
          <li className="link">
            <Link to="/home">Home</Link>
          </li>
          <li className="link">
            <Link to="/bookingconsultation">Appointments</Link>
          </li>
          <li className="link">
            <Link to="/instantconsultation">Instant Consultation</Link>
          </li>
          <li className="link">
            <Link to="/healthblog">Health Blog</Link>
          </li>
          <li className="link">
            <Link to="/reviewform">Reviews</Link>
          </li>
          {isLoggedIn ? (
            <>
              <li className="link welcome-user">
                {`Welcome, ${getUserName()}`}
                <ul className="dropdown-menu">
                  <li>
                    <Link to="/profilecard">Your Profile</Link>
                  </li>
                  <li>
                    <Link to="/reportslayout">Your Reports</Link>
                  </li>
                </ul>
              </li>
              <li className="link">
                <button type="button" className="btn2" onClick={handleLogout}>
                  Logout
                </button>
              </li>
            </>
          ) : (
            <>
              <li className="link mr">
                <Link to="/signup">
                  <button type="button" className="btn1">
                    Sign Up
                  </button>
                </Link>
              </li>
              <li className="link">
                <Link to="/login">
                  <button type="button" className="btn1">
                    Login
                  </button>
                </Link>
              </li>
            </>
          )}
        </ul>
      </nav>
    </header>
  );
}
